import React, { Fragment, useEffect, useRef, useState } from "react";
import profilfeUserImg from "assets/images/common/others/dpIcon.png";
import attendeAvatar from "assets/images/common/others/attendeAvatar.png";
import { ReactComponent as DeleteIconSvg } from "assets/images/common/svgs/delete.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import ProfileUSer from "assets/images/common/others/profile-user-img.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import useUsers from "containers/user-management/useHooks";
import DataNotFound from "components/particles/table/data-not-found";

type Message = {
  id: number;
  sender: string;
  message: string;
  time: string;
};

const messages: Message[] = [
  {
    id: 1,
    sender: "Sam Curran",
    message: "Hello! Have you seen my backpack anywhere in office?",
    time: "15:42",
  },
  {
    id: 2,
    sender: "Sam Curran",
    message: "Hello! Have you seen my backpack anywhere in office?",
    time: "15:42",
  },
  {
    id: 3,
    sender: "Sam Curran",
    message:
      "I'm planning to start a small café, but I want it to stand out. Thinking of a book-themed café where people can read and relax. Any thoughts on how to attract customers?",
    time: "15:42",
  },
  {
    id: 4,
    sender: "Sam Curran",
    message:
      "That's a cool idea! You could add a monthly book club event or partner with local authors for book signings. Maybe even offer discounts for students who bring their own books.",
    time: "15:42",
  },
  {
    id: 5,
    sender: "Katrina A",
    message:
      "Love that! You could also have a 'coffee and creativity' corner—provide art supplies for people to sketch or write while they enjoy their coffee. And don't forget about social media—posting aesthetic shots of the café could bring in traffic!",
    time: "15:42",
  },
];

const ViewCommunity = () => {
  const [event, setEvent] = useState<any>({});
  const { getQueryParams } = useUtils();
  const { getEventDetailById } = useUsers();
  const [messages, setMessages] = useState<any[]>([]);
  const [pagination, setPagination] = useState({
    count: 0,
    currentPage: 0,
    totalPages: 1,
  });
  const { getCommunityMessageById } = useUsers();

  const pageSize = 10;
  const containerRef = useRef<HTMLDivElement>(null);
  const prevScrollHeight = useRef(0);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();
  const eventId = params?.id;

  useEffect(() => {
    getEventDetailById(params?.id, setEvent);
  }, []);
  console.log(params?.id);
  const navigate = useNavigate();
  const goToBack = () => {
    navigate(-1);
  };

  const loadMessages = (page: number) => {
    const container = containerRef.current;
    if (page > 0 && container) {
      // record scrollHeight before prepend
      prevScrollHeight.current = container.scrollHeight;
    }
    getCommunityMessageById(
      setMessages,
      eventId,
      setPagination,
      page,
      pageSize
    );
  };

  // initial load on eventId change
  useEffect(() => {
    setMessages([]);
    loadMessages(0);
  }, [eventId]);

  // adjust scroll after messages update
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    if (pagination.currentPage === 0) {
      // initial load → scroll to bottom (newest)
      container.scrollTop = container.scrollHeight;
    } else {
      // older messages prepended → keep view at same items
      const newHeight = container.scrollHeight;
      const diff = newHeight - prevScrollHeight.current;
      container.scrollTop = diff;
    }
  }, [messages, pagination.currentPage]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop } = e.currentTarget;
    // when user scrolls to near top, load older if any
    if (scrollTop <= 50 && pagination.currentPage + 1 < pagination.totalPages) {
      loadMessages(pagination.currentPage + 1);
    }
  };

  const formatDateHeading = (dateStr: string): string => {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (d1: Date, d2: Date) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDay(date, today)) return "Today";
    if (isSameDay(date, yesterday)) return "Yesterday";

    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatTime = (dateStr: string): string =>
    new Date(dateStr).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });

  // for date headings
  let lastShownDate: string | null = null;

  return (
    <div>
      <div className="flex justify-between items-center gap-4 mb-6">
        <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {event?.event?.title || ""}
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">
              Block Community
            </p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-redtext">Delete Community</p>
            <DeleteIconSvg />
          </span>
        </div> */}
      </div>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="flex flex-wrap gap-4 items-center">
          <h1 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            {event?.event?.title || ""}
          </h1>
          <p className="bg-peachFadeBg text-darkYellowText text-sm font-medium rounded-md  px-2 py-1">
            {event?.event?.isSession ? "Session" : "Workshop"}
          </p>
          <p className="text-sm font-medium text-captionText">
            {event?.event?.availableSlots || ""} Slots Available
          </p>
        </div>
        <div className="flex items-center gap-4 my-3">
          <div className="flex -space-x-2">
            <img
              src={attendeAvatar}
              alt="Attendee"
              className="w-8 h-8  rounded-full border-1 border-white"
            />
            <img
              src={attendeAvatar}
              alt="Attendee"
              className="w-8 h-8  rounded-full border-1 border-white"
            />
            <img
              src={attendeAvatar}
              alt="Attendee"
              className="w-8 h-8 rounded-full border-1 border-white"
            />
          </div>
          <span className="text-base font-semibold text-warmGray">
            {event?.event?.joinSlots && event?.event?.availableSlots
              ? `${event.event.joinSlots - event.event.availableSlots} Going`
              : "0 Going"}
          </span>
        </div>
        <div className="">
          {/* Messages */}
          <div
            ref={containerRef}
            className="py-6 overflow-y-auto max-h-[500px]"
            onScroll={handleScroll}
          >
            {messages.map((msg) => {
              const msgDate = new Date(msg.createdAt).toDateString();
              const showHeading = msgDate !== lastShownDate;
              lastShownDate = msgDate;

              return (
                <React.Fragment key={msg.id}>
                  {showHeading && (
                    <div className="text-center text-xs text-uiGrayText my-4">
                      {formatDateHeading(msg.createdAt)}
                    </div>
                  )}
                  <div className="mb-5">
                    <div className="flex items-start gap-3 sm:gap-4">
                      <img
                        src={msg.userProfilePic}
                        alt="Profile"
                        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex-shrink-0"
                      />
                      <div className="bg-culturedBg rounded-tl-none rounded-lg p-3 sm:px-4 max-w-full sm:max-w-2xl w-fit">
                        <div className="font-semibold text-sm text-primaryText mb-1">
                          {msg.userName}
                        </div>
                        <div className="text-sm text-primaryText whitespace-pre-line break-words">
                          {msg.message}
                        </div>
                        <div className="text-xs text-uiGrayText mt-1">
                          {formatTime(msg.createdAt)}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
        <Fragment>
          <DataNotFound show={!isLoading && !messages.length} />
        </Fragment>
      </div>
    </div>
  );
};

export default ViewCommunity;
